// 12/13/2021 TODO (classic for joe):
// - make the post-reflection box into 3

// Comment on how you think things went in this meeting.
// Comment on how the other character(s) behaved and what you may have done to cause those behaviors.
// Comment on what you could try that might improve your performance next time.

// - shirnk SVG and improve button size (classiv version)

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';
import { configureStore } from 'app/store';
import { BrowserRouter as Router } from 'react-router-dom';
import { App } from './app';

// Import our blueprint & normalize css
import 'normalize.css';
import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/icons/lib/css/blueprint-icons.css";
import "@blueprintjs/select/lib/css/blueprint-select.css";
import "@blueprintjs/table/lib/css/table.css";
import 'react-table/react-table.css';

// Import our custom CSS up top
import './app/index.css';

import * as Sentry from '@sentry/browser';
import Clarity from '@microsoft/clarity';
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";

import { useEffect } from 'react';

// Component wrapper approach to prevent back button
export const BackButtonPreventer = ({ children }) => { 
  useEffect(() => {
    // Create a function to handle back button prevention
    const preventBackNavigation = () => {
      window.history.pushState(null, null, window.location.pathname);
    };

    // Add an entry to the history stack
    preventBackNavigation();

    // Handle popstate events (back/forward button clicks)
    const handlePopState = (event) => {
      // Immediately push a new state to prevent going back
      preventBackNavigation();
    };

    // Add the event listener
    window.addEventListener('popstate', handlePopState);

    // Also add a beforeunload handler to catch other navigation attempts
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = '';
      return '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    // Additional protection: override the back button via history manipulation
    const originalPushState = window.history.pushState;
    const originalReplaceState = window.history.replaceState;

    window.history.pushState = function(...args) {
      originalPushState.apply(window.history, args);
      // Immediately add another entry to prevent going back
      setTimeout(() => {
        originalPushState.call(window.history, null, null, window.location.pathname);
      }, 0);
    };

    // Cleanup function
    return () => {
      window.removeEventListener('popstate', handlePopState);
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.history.pushState = originalPushState;
      window.history.replaceState = originalReplaceState;
    };
  }, []);

  return children;
};

// Aggressive back button prevention - run immediately
(function() {
  let isBackButtonDisabled = false;
  
  const disableBackButton = () => {
    if (isBackButtonDisabled) return;
    isBackButtonDisabled = true;
    
    // Push multiple states to make it harder to go back
    for (let i = 0; i < 10; i++) {
      window.history.pushState(null, null, window.location.href);
    }
    
    // Override history methods
    const originalBack = window.history.back;
    const originalGo = window.history.go;
    
    window.history.back = function() {
      // Do nothing - ignore back button
      return false;
    };
    
    window.history.go = function(n) {
      if (n < 0) {
        // Ignore backward navigation
        return false;
      }
      return originalGo.call(this, n);
    };
    
    // Listen for popstate and counter it immediately
    window.addEventListener('popstate', function(e) {
      window.history.pushState(null, null, window.location.href);
    }, true);
  };
  
  // Run immediately
  disableBackButton();
  
  // Also run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', disableBackButton);
  } else {
    disableBackButton();
  }
})();

// prepare store and history globally
const history = createBrowserHistory();
const store = configureStore();

// Bake a hash into our application, allowing us to manually set and check when updates occur
// We follow a pretty standard
// X.Y.4
// X is major, non reverse compatible release
// Y is a potentially reverse breaking, new feature or major change
// Z is a minner, often cosmetic patch

const CURRENT_SOFTWARE_VERSION = '3.7.10 - dev';  // 1 will be there till a new project is issues
// increment the second when an API change accompanies
window["IN_DEV_MODE"] = true;

window["CURRENT_SOFTWARE_VERSION"] = CURRENT_SOFTWARE_VERSION;

// Initialize sentry - TEMPORARILY DISABLED (Why?)
// Sentry.init({
//     dsn: "https://bdbfadf818144c8c85c0f1fb1b6d2e58@o388149.ingest.sentry.io/5224569",
//     release: CURRENT_SOFTWARE_VERSION,
// });

try {
    Clarity.init('r7efkvxy1j');
}
catch(e) {

}

// Set the build, so we can track it in sentry - TEMPORARILY DISABLED
// Sentry.configureScope(function (scope) {
//     scope.setExtra(
//         "build", CURRENT_SOFTWARE_VERSION
//     );
// });

Clarity.init("r7efkvxy1j");

// Wrap our *App* definition in the provider and router
ReactDOM.render(
    <BackButtonPreventer>
        <I18nextProvider i18n={i18n}>
        <Provider store={store}>
            <Router history={history}>
                
                    <App />
                
            </Router>
        </Provider>
    </I18nextProvider>
    </BackButtonPreventer>,
    document.getElementById('root')
);
